import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";

import { tss } from "tss-react/mui";
import { useAppSelector } from "_redux/hooks";
import { selectHasOnlineSellers } from "_redux/selectors/catalog";
import { selectDisplayNameOfStore } from "_redux/selectors/site";

const useStyles = tss.create(({ theme }) => ({
  marginTop: {
    marginTop: theme.spacing(2),
  },
}));

export type AllowSyncDialogParams = Record<string, unknown>;

const AllowSyncDialogContent: FC<{
  showAdditionalDescriptionOverride?: boolean;
  hideStoreName?: boolean;
}> = ({ showAdditionalDescriptionOverride, hideStoreName }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const storeName = useAppSelector(selectDisplayNameOfStore);
  const hasSellers = useAppSelector(selectHasOnlineSellers);
  const showAdditionalDescription =
    showAdditionalDescriptionOverride != null
      ? showAdditionalDescriptionOverride
      : hasSellers;

  return (
    <>
      <Typography variant="subtitle2" component="p">
        {hideStoreName
          ? t("offline.allowSyncDialog.descriptionWithoutStoreName")
          : t("offline.allowSyncDialog.description", { storeName })}
      </Typography>
      {showAdditionalDescription && (
        <Typography
          className={classes.marginTop}
          variant="subtitle2"
          component="p">
          {t("offline.allowSyncDialog.additionalDesc")}
        </Typography>
      )}
      <Typography
        className={classes.marginTop}
        variant="subtitle1"
        component="p">
        {t("offline.allowSyncDialog.hint")}
      </Typography>
    </>
  );
};

export default AllowSyncDialogContent;
